// @flow

import { Lock, PenLine } from 'lucide-react';

import { PillButton } from 'src/components/PillButton';

export function SetupPill({
  children,
  to,
  onClick,
  disabled = false,
}: {
  children: string | React.MixedElement,
  to?: string,
  disabled?: boolean,
  onClick?: (evt: SyntheticEvent<HTMLButtonElement>) => void,
}): React.MixedElement {
  const enabled = !disabled && (!!to || !!onClick);

  const icon = enabled ? <PenLine size={12} /> : <Lock size={12} />;

  return (
    <PillButton to={to} onClick={onClick} disabled={!enabled}>
      {children}
      {icon}
    </PillButton>
  );
}
